import { render, staticRenderFns } from "./LogisticsRecordPop.vue?vue&type=template&id=0c44dea3&scoped=true&"
import script from "./LogisticsRecordPop.vue?vue&type=script&lang=js&"
export * from "./LogisticsRecordPop.vue?vue&type=script&lang=js&"
import style0 from "./LogisticsRecordPop.vue?vue&type=style&index=0&id=0c44dea3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c44dea3",
  null
  
)

export default component.exports